export default "__VITE_ASSET__CRYBZYme__"